import { CheckIcon } from "@/components/icons";

type StatusDialogProps = {
  open: boolean;
  title: string;
  message: string;
  detail?: string;
  tone?: "success" | "warning";
  actionLabel?: string;
  onAction?: () => void;
  onClose: () => void;
};

export function StatusDialog({
  open,
  title,
  message,
  detail,
  tone = "success",
  actionLabel,
  onAction,
  onClose,
}: StatusDialogProps) {
  if (!open) return null;
  return (
    <div className="modal-backdrop" role="presentation">
      <section
        aria-describedby="status-message"
        aria-labelledby="status-title"
        aria-modal="true"
        className="status-dialog"
        role="dialog"
      >
        <header className="dialog-header">
          <button className="dialog-close" type="button" onClick={onClose}>
            Schließen
          </button>
          <h2 id="status-title">Status</h2>
        </header>
        <div className="status-content">
          <div className={`status-symbol ${tone}`}>
            <CheckIcon />
          </div>
          <h3>{title}</h3>
          <p id="status-message">{message}</p>
          {detail && <p className="dialog-detail">{detail}</p>}
          <div className="dialog-actions">
            {actionLabel && onAction && (
              <button
                className="button button-secondary"
                type="button"
                onClick={onAction}
              >
                {actionLabel}
              </button>
            )}
            <button
              className="button button-primary"
              type="button"
              onClick={onClose}
            >
              Fertig
            </button>
          </div>
        </div>
      </section>
    </div>
  );
}
